import React from 'react'

const Footer = () => {
  return (
    <div className='text-center text-white bg-neutral-900'>
        <p className='text-sm p-1'>Copyright © Sajid Islam 2026</p>
    </div>
  )
}

export default Footer